// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var Api = {
  name: "PageContext"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Api);

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var use = include.use;

export {
  Api ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
}
/* include Not a pure module */
